export const reactionTypes = [
  "like",
  "love",
  "wow",
  "haha",
  "angry",
  "unlike",
  "sad",
] as const;
